import React from 'react';
import { Atom } from 'AppReact';
import styled from 'styled-components';


export default Atom({ type: 'custom', dataType: 'string', template: styled.div`` })
